import * as yup from 'yup';

export const TeacherEvaluationFormValidation = yup.object().shape({
    description: yup.string().required('Critério de avaliação é obrigatória'),
    isForStudent: yup.boolean().required('É obrigatório'),
    status: yup.boolean().required('É obrigatório'),
});